<template>
  <div class="home">
    <div class="h-top">
      <TopMenu :isLogin="isLogin"></TopMenu>
    </div>
    <div class="h-middle">
      <MiddleContent></MiddleContent>
    </div>
    <div class="bottom-btn">
      <a-button type="primary" class="soon-touch" @click="goLogin">
        <label class="touch-font">立即体验 
          <!-- <a-icon type="double-right" style="color:rgb(192 216 231)" /> -->
          <i class="btn-left"></i>
        </label>
      </a-button>
    </div>
    <div class="h-bottom">
      <div class="b-top">
        <label><a href="https://www.hundsun.com/">恒生电子</a></label>
        <span>|</span>
        <label><a href="https://www.hundsun.com/about">关于我们</a></label>
      </div>
      <div class="b-mid"> <a href="https://www.hundsun.com/">恒生电子 Hundsun</a></div>
      <div class="b-mid">
        Copyright © 2023 Business Intelligence Info. Tech. (Hangzhou) Co., LTD. All Rights Reserved 浙ICP备2020040706号-1 <i></i> 浙公网安备 33010802011289号
      </div>
    </div>
  </div>
</template>
<script>
import TopMenu from '@/components/home/TopMenu.vue';
import MiddleContent from '@/components/home/MiddleContent.vue';
/* 首页 */
export default {
  name: 'HomePage',
  components: {
    TopMenu,
    MiddleContent
  },
  props: {},
  watch: {},
  data() {
    return {
      isLogin: false
    };
  },
  computed: {},
  created() {
    this.getLoginState();
  },
  mounted() {
    const user =  localStorage.getItem('user');
    console.log('user---', user);
    console.log('user---', JSON.parse(user));
  },
  methods: {
    goLogin() {
      // const url = 'http://localhost:8008'; //
      const url = window.location.origin;
      console.log('url', url);
      window.location.href = window.CONFIG_OBJ.fundUrl // url + '/front-layout/login'
    },
    getLoginState() {
      const user = localStorage.getItem('user');
      if (user) {
        this.isLogin = true;
      }
      console.log('this.isLogin', this.isLogin);
    }
  }
};
</script>

<style lang='less' scoped>
.home {
  position: relative;
  overflow: hidden;
  .h-top {
    margin: auto;
    max-width: 1440px;
    min-width: 1280px;
  }
  .h-middle {
    display: flex;
    justify-content: center;
    height: calc(84vh - 72px);
    background: #F5F7FC;
  }
  .bottom-btn {
    position: absolute;
    bottom: 18vh;
    left: 50%;
    transform: translateX(-50%);
    .soon-touch {
      width: 194px;
      height: 52px;
      .touch-font {
        font-size: 18px;
        font-family: DingTalk-JinBuTi;
        font-weight: 400;
        color: #FFFFFF;
        cursor: pointer;
        .btn-left {
          display: inline-block;
          width: 16px;
          height: 14px;
          background: url(~@/assets/btn-left.png);
          background-size: 100% 100%;
        }
      }
    }
  }
  .h-bottom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 16vh;
    background: #fff;
    .b-top {
      text-align: center;
      font-size: 14px;
      color: #000;
      span {
        display: inline-block;
        padding: 0 10px;
        vertical-align: 1px;
      }
      a {
        color: #333;
      }
      a:hover {
        color: #298dff;
      }
    }
    .b-mid {
      padding-top: 5px;
      text-align: center;
      font-size: 14px;
      color: #999;
      i {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url(~@/assets/police.png);
        background-size: 100% 100%;
        vertical-align: -2px;
      }
      a {
        color: #333;
      }
      a:hover {
        color: #298dff;
      }
    }
  }
}
</style>